<div class="promo-dialog-wrapper">
  <p class="promo-title">Código promocional</p>

  <div class="promo-input-row">
    <input
      class="promo-input"
      type="text"
      placeholder="Introduce el código"
      [(ngModel)]="code"
      (keyup.enter)="validate()"
      [disabled]="validating || applying"
      autocomplete="off"
    />
    <button class="btn-validate" (click)="validate()" [disabled]="!code || validating || applying">
      {{ validating ? 'Validando...' : 'Validar' }}
    </button>
  </div>

  <!-- Preview -->
  <div *ngIf="preview && !error" class="promo-preview">
    <fa-icon [icon]="faCircleCheck" class="icon-ok"></fa-icon>
    <span>Descuento:
      <strong *ngIf="preview.discount_mode === 'percentage'">{{ preview.discount_value }}%</strong>
      <strong *ngIf="preview.discount_mode !== 'percentage'">{{ formatNumber(preview.discount_value) }}</strong>
    </span>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="promo-error">
    <fa-icon [icon]="faCircleX" class="icon-error"></fa-icon>
    {{ error }}
  </div>

  <div class="promo-actions">
    <button class="btn-cancel" (click)="cancel()">Cancelar</button>
    <button class="btn-apply" (click)="apply()" [disabled]="!preview || applying">
      {{ applying ? 'Aplicando...' : 'Aplicar' }}
    </button>
  </div>
</div>
